import React, { useState, useEffect, useCallback } from "react";
import './Styles/StepperStyle.css';
import BasicInfo from "./Components/BasicInfo";
import CivilStatusCard from "./Components/CivilStatusCard";
import HomeAddress from "./Components/HomeAddress";
import CareerInfo from "./Components/CareerInfo";
import PhoneNumber from "./Components/PhoneNumber";
import MaritalStatus from "./Components/MaritalStatus";
import SignatureOfTaxPayer from "./Components/SignatureOfTaxPayer";
import ChildredList from "./Components/ChildredList";
import ImagesUpload from "./Components/ImagesUpload";
import VerticalTabs from "./Components/VerticalTabs";
import ExportPdf from "./Components/ExportPdf";
import StepperIncomeTaxReport from "./StepperIncomeTaxReport";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IncomeEstimateForm from "./IncomeEstimateForm";
import axios from "axios";
import $ from 'jquery';
import { useGlobalContext } from "../../../../../context";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Cookies from "universal-cookie";
import swal from "sweetalert";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import SourceOfIncome from "./Components/SourceOfIncome";
import SummationOfIncomeResources from "./Components/SummationOfIncomeResources";
import Discounts from "./Components/Discounts";
import Permitted from "./Components/Permitted";
import TaxableIncome from "./Components/TaxableIncome";
import Fines from "./Components/Fines";
import Interest from "./Components/Interest";
import PaymentsInfo from "./Components/PaymentsInfo";
import CommentOfEstimators from "./Components/CommentOfEstimators";
import CommentsOfChecker from "./Components/CommentsOfChecker";
import CommentOfBranchManger from "./Components/CommentOfBranchManger";
import ApprovalesDetials from "./Components/ApprovalesDetials";
import OtherBusinessForm from './OtherBusinessForm'
import IncomeEstimateClass from "./IncomeEstimateClass";
import Loading from "./Loading";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function ViewIncomeTaxReport(props) {
  const [object, setObject] = useState(props.object)
  // const [loading, setLoading] = useState(false);
  // const {fetchData}=useGlobalContext();
  const [tabsArray,setTabsArray]=useState([])
  const [sections,setSections]=useState([]);
  const [FormatingStepper,setFormatingStepper]=useState([])
  const [activeStep,setActiveStep]=useState(0)
  const [cureentStageTransactionType,setCurrentStageTransactionType]=useState({});
  const [permissionsForCurrentStage,setPermissionsForCurrentStage]=useState(true);
  const [permissions,setPermissions]=useState([]);

  const [inactive, setInactive] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const [snackBar2, setsnackBar2] = useState({
    open: false,
    vertical: "center",
    horizontal: "center",
    message: [],
    severity: "warning",
  });
  const [IPaddress, setIPaddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);


  const [userRole, setUserRole] = useState(cookies.get("role_id"));
  const [userName, setUserName] = useState(cookies.get("userName"));
  const [selecetedAmount, setSelecetedAmount] = useState(0);

  const [user, setUser] = useState({});
  // income resource with values  hooks here...
  const [incomeResourceValuesArrOBJ, setIncomeResourceValuesArrOBJ] = useState(
    []
  );
  const [selectedIncomeResourceValue, setSelectedIncomeResourceValue] =
    useState(null);
  const [listOFIncomeResourceValue,setListOFIncomeResourceValue] = useState([]);
  const [summationOfAllResources,setSummationOfAllResources] = useState(0);

  // discount ....
  const [discountValuesArrOBJ, setDiscountValuesArrOBJ] = useState([]);
  const [selectedDiscountValuesArrOBJ, setSelectedDiscountValuesArrOBJ] =
    useState(null);
  const [listOFDiscountValuesArrOBJ, setListOFDiscountValuesArrOBJ] = useState(
    []
  );

  // taxable income ...
  const [taxableIncome, setTaxableIncom] = useState(0);
  const [taxableAmount, setTaxableAmount] = useState(null);

  // fines ....
  const [finesValuesArrOBj, setFinesValuesArrOBj] = useState([]);
  const [selectedFinesValuesArrOBj, setSelectedFinesValuesArrOBj] =
    useState(null);
  const [listOFFinesValuesArrOBJ, setListOFFinesValuesArrOBJ] = useState([]);

  // interests ....
  const [interestedValuesArrOBj, setInterestedValuesArrOBj] = useState([]);
  const [selectedInterestedValuesArrOBj, setSelectedInterestedValuesArrOBj] =
    useState(null);
  const [listOFInterestedValuesArrOBj, setListOFInterestedValuesArrOBj] =
    useState([]);

  //payments
  const [voucherNumber, setVoucherNumber] = useState("");
  const [voucherDate, setVoucherDate] = useState(new Date());
  const [ownerDecision, setOwnerDesision] = useState(cookies.get('role_id')==4?false:null);
  const [ownerDecisionDate, setOwnerDecisionDate] = useState(new Date());

  //other hooks
  const [taxAssessor, setTaxAssessor] = useState("");
  const [taxAssessorComments, setTaxAssessorComments] = useState("");

  const [checkerName, setCheckerName] = useState("");
  const [checkerNameComments, setCheckerNameComments] = useState("");

  const [branchManager, setBranchManager] = useState("");
  const [branchManagerComments, setBranchManagerComments] = useState("");
  const [FinalCalculation, setFinalCalculation] = useState({});
  const [disableIncome, setDisableIncome] = useState(false);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [ModeOfInsertData, setModeOfInsertData] = useState("أضافة");
  const [ModeOfInsertData_tow, setModeOfInsertData_tow] = useState("حساب");
  const [renderCheck,setRenderCheck]=useState(false)
  const [sectionSelected,setSectionSelected]=useState(null)
  const [compleletStage,setCompleteStage]=useState(false)
  const [rerender,setRerender]=useState(0)
  const [currentCompleteStage,setCurrentCompleteStage]=useState([])
  const [mainTransaction,setMainTransaction]=useState({});
  const [loadFetchData,setLoadFetchData]=useState(true)
  const {
    // loading,
    incomeResourceValues,
    interestReasonValues,
    fineReasonValues,
    discountReasonValues,
    permitReasonValues,
    User,
    fetchData,
    setUserInfo,
  } = useGlobalContext();

  useEffect(() => {
    fetchData("INCOME_RESOURCE_VALUES", "income_resource_values_list", {});
    fetchData("INTEREST_REASON_VALUES", "interest_reason_values_list", {});
    fetchData("FINE_REASON_VALUES", "fine_reason_values_list", {});
    fetchData("DISCOUNT_REASON_VALUES", "discount_reason_values_list", {});
    fetchData("PERMIT_REASON_VALUES", "permit_reason_values_list", {});
    setIPaddress(ApiSetting.apiUrl);
    getSelectedAmountForIncomeResource_classess()
    // setTimeout(()=>{
      getSelectedAmountForIncomeResource()
      getRepordEstimateInfo(ApiSetting.apiUrl);
    // },50)
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
     getCalculationsForAmount(1);

    setUserRole(cookies.get("role_id"));
    setUserName(cookies.get("userName"));
    console.log(cookies.get("role_id"));
    // if (cookies.get("role_id") == 1) {
    //   setUserInfo({ userName: "branch manager", role_id: 1 });
    //   setBranchManager("branch manager");
    // } else if (cookies.get("role_id") == 2) {
    //   setUserInfo({ userName: "checker", role_id: 2 });
    //   setCheckerName("checker");
    // } else if (cookies.get("role_id") == 3) {
    //   setUserInfo({ userName: "estimator", role_id: 3 });
    //   setTaxAssessor("tax payer");
    // } else if (cookies.get("role_id") == 4) {
    //   setUserInfo({ userName: "tax payer", role_id: 4 });
    // }
  }, []);
  console.log(User);

  useEffect(() => {
    if (incomeResourceValues.length > 0) {
      setIncomeResourceValuesArrOBJ([
        ...incomeResourceValues,
        { id: incomeResourceValues.length + 1, resource: "other" },
      ]);
    }
  }, [incomeResourceValues]);

  useEffect(() => {
    if (discountReasonValues.length > 0) {
      setDiscountValuesArrOBJ([
        ...discountReasonValues,
        { id: discountReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [discountReasonValues]);

  useEffect(() => {
    if (fineReasonValues.length > 0) {
      setFinesValuesArrOBj([
        ...fineReasonValues,
        { id: fineReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [fineReasonValues]);

  useEffect(() => {
    if (interestReasonValues.length > 0) {
      setInterestedValuesArrOBj([
        ...interestReasonValues,
        { id: interestReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [interestReasonValues]);

  useEffect(() => {
    summationOfAllResourcesFunction_update();
  }, [
    listOFDiscountValuesArrOBJ,
    listOFFinesValuesArrOBJ,
    listOFIncomeResourceValue,
    listOFInterestedValuesArrOBj,
  ]);

  // useEffect(()=>{


  // },[currentCompleteStage])

  useEffect(()=>{
      // setRerender(rerender+1);
  })

  const getCurrentReportDataAfterUpdate=async ()=>{
    let data=null;
    try{
      data=await axios({
         method: "GET",
         url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
         headers:{
          'content-type': 'application/json',
          'accept': 'application/json;',
          "X-localization": language,
         }
      })
      if(data){
          if(data?.data?.status==200){
             setObject(data?.data?.data)
             setRenderCheck(!renderCheck)

          }else{
            console.log(data?.data?.message)
          }
      } 

    }catch(err){
      console.log(err.message)
    }
  }

  const getAllSectionsForThisTransaction=async()=>{
    let data=null;
    try{
      data=await axios({
        method: 'post',
        url:ApiSetting.apiUrl+'/income_tax_report/get_all_sections_for_this_transaction',
        data:{
          user_role_id:cookies.get('role_id')?parseInt(cookies.get('role_id'))+1:'',
          income_report_id:props?.object?.id,
          user_id:cookies.get('user_id')?parseInt(cookies.get('user_id')):''
        },
        headers:{
          'Content-Type':'application/json',
          'accept':'application/json',
          "X-localization": language,
        }
      })

      if(data){
         if(data?.data?.status==200){
            // if(!check)
              reformatResponseForStepper(data?.data?.data)
            // else 
            //   reformatResponseForStepper2(data?.data?.data)

         }else{
           console.log(data?.data?.message);
         }
      }
    }catch(err){
      console.log(err.message)
    }
  }

  const reformatResponseForStepper=(data)=>{
       let arr=[];
       if(data?.transactions?.length==0){
            return
       }
       setMainTransaction(data?.transactions)
       let counter_step=0;
       let arr_sections=[];
       data?.transactions?.stage_transaction_type?.stage_transaction_type_sections?.map((itm)=>{
          data?.transactions?.stage_transaction_type?.sections?.map((itm2)=>{
              if(itm?.section_id==itm2?.id){
                 if(itm?.role_stage_transaction_type?.length>0){
                  arr_sections.push(itm2)
                 }
              }
          })
       })
      setSections(arr_sections)
        // if(arr_sections?.length==0)
        // setRenderCheck(!renderCheck)

      setCurrentStageTransactionType(data?.transactions?.stage_transaction_type)
        // data?.transactions?.map((item,index)=>{
            // if(index==data?.transactions?.length-1){
              data?.transactions?.transaction_type?.stage_transaction_type?.map((stageTraType)=>{
                    let arr_2={}
                    let count_check=0;
                    let count_check_tow=0;
                    let count_check_rejected=0;
                    let status=false;
                    let status_reject=false;

                    stageTraType?.transaction_approval?.map((approv)=>{
                          if(data?.transactions?.id==approv?.transaction_id){
                            if(approv?.approval_status?.id==2|| approv?.stage_transaction_type_approval?.is_mandatory==0){
                              count_check++;
                            }

                            if(approv?.approval_status?.id==3&&approv?.stage_transaction_type_approval?.is_mandatory==1){
                              count_check_rejected++;
                            }
                            count_check_tow++
                        }
                    })

                    if(count_check==count_check_tow&&count_check==stageTraType?.stage_transaction_type_approval?.length){
                      status=true;
                    }

                    if(stageTraType?.stage_transaction_type_approval?.length==0){
                      status=true;
                    }

                    if(status){
                      counter_step=arr.length+1;
                    }

                    if(count_check_rejected>0){
                      status=7
                    }

                    if(data?.transactions?.stage_transaction_type?.id==stageTraType?.id){

                      if(status!==7)
                      setCompleteStage(status)
                    }

                  
                    arr_2={
                      income_report_id:props?.object?.id,
                      transactions_id:data?.transactions?.id,
                      transaction_type_id:data?.transactions?.transaction_type?.id,
                      stage_name:stageTraType?.stage?.name,
                      stage_id:stageTraType?.stage?.id,
                      stage_transaction_type_id:stageTraType?.id,
                      order_number:stageTraType.order_number,
                      status:status,
                    }
                    arr.push(arr_2) 
              })
          // }
        // })
      
      setActiveStep(counter_step)
      setFormatingStepper(arr)
      setLoadFetchData(false)

  }

  const reformatResponseForStepper2=(data)=>{
    let arr=[];
    if(data?.transactions?.length==0){
         return
    }
    let counter_step=0;
  //   let arr_sections=[];
  //   data?.transactions?.stage_transaction_type?.stage_transaction_type_sections?.map((itm)=>{
  //      data?.transactions?.stage_transaction_type?.sections?.map((itm2)=>{
  //          if(itm?.section_id==itm2?.id){
  //             if(itm?.role_stage_transaction_type?.length>0){
  //              arr_sections.push(itm2)
  //             }
  //          }
  //      })
  //   })
  //  setSections(arr_sections)
  //    // if(arr_sections?.length==0)
  //    // setRenderCheck(!renderCheck)

    //  setCurrentStageTransactionType(data?.transactions?.stage_transaction_type)
     // data?.transactions?.map((item,index)=>{
         // if(index==data?.transactions?.length-1){
           data?.transactions?.transaction_type?.stage_transaction_type?.map((stageTraType)=>{
                 let arr_2={}
                 let count_check=0;
                 let count_check_tow=0;
                 let count_check_rejected=0;
                 let status=false;
                 let status_reject=false;

                 stageTraType?.transaction_approval?.map((approv)=>{
                       if(data?.transactions?.id==approv?.transaction_id){
                          if(approv?.approval_status?.id==2|| approv?.stage_transaction_type_approval?.is_mandatory==0){
                            count_check++;
                          }
                          if(approv?.approval_status?.id==3&&approv?.stage_transaction_type_approval?.is_mandatory==1){
                            count_check_rejected++;
                          }
                          count_check_tow++
                        }
                 })

                 if(count_check==count_check_tow&&count_check==stageTraType?.stage_transaction_type_approval?.length){
                   status=true;
                 }

                 if(stageTraType?.stage_transaction_type_approval?.length==0){
                   status=true;
                 }

                 if(status){
                   counter_step=arr.length+1;
                 }
        
                 if(count_check_rejected>0){
                  status_reject=true
                  }

                 if(data?.transactions?.stage_transaction_type?.id==stageTraType?.id){
                   setCompleteStage(status)
                 }

                 
                
               
                 arr_2={
                   income_report_id:props?.object?.id,
                   transactions_id:data?.transactions?.id,
                   transaction_type_id:data?.transactions?.transaction_type?.id,
                   stage_name:stageTraType?.stage?.name,
                   stage_id:stageTraType?.stage?.id,
                   stage_transaction_type_id:stageTraType?.id,
                   status:status,
                   status_reject:status_reject,
                 }
                 arr.push(arr_2) 
           })
       // }
     // })
   
     setActiveStep(counter_step)
    setFormatingStepper(arr)

}


  useEffect(() => {
    setObject(props.object)
    // fetchData('SECTIONS','sections_list',{})
    getAllSectionsForThisTransaction()
    console.log(props.object);
  }, [props.object]);

  // console.log("view props.object",props.object);
  const getCurrentPermissionForThisRoles=(id) => {
    console.log('log-1.1.a')
    let access_type=[];
    cureentStageTransactionType?.stage_transaction_type_sections?.map((data)=>{
    console.log('log-1.1.a.1')

       if(data?.section_id==id){
         console.log('log-1.1.a.1.b')

           data?.role_stage_transaction_type?.map((itm)=>{
             console.log('log-1.1.a.1.b.1')

              if(itm?.role_id==(parseInt(cookies.get('role_id'))+1)&&itm?.stage_transaction_type_section_id==data?.id){
               console.log('log-1.1.a.1.b.1.c')
  
                 itm?.permissions?.map((perm)=>{
                   console.log('log-1.1.a.1.b.1.c.1',perm?.id)

                    access_type.push(perm?.id)
                 })
              }
           }) 
       }
    })
    return access_type;
  }

  const getCurrentPermissionForThisRoles2=(id) => {
    console.log('log-1.2.1')

    let access_type=[];
    permissions?.map((data)=>{
    console.log('log-1.2.1.1')

       if(data?.section_id==id){
        console.log('log-1.2.1.1.1',data?.per)
          access_type=data?.per
       }
    })
    return access_type;
  }


  useEffect(()=>{
    let arr=[];
      arr.push({
        label:'الموافقات',
        content:<ApprovalesDetials 
                  cureentStageTransactionType={cureentStageTransactionType}
                  setCurrentStageTransactionType={setCurrentStageTransactionType}
                  income_report_id={props?.object?.id}
                  setPermissions={setPermissions}
                  setSections={setSections}
                  setPermissionsForCurrentStage={setPermissionsForCurrentStage}
                  getAllSectionsForThisTransaction={getAllSectionsForThisTransaction}
                  compleletStage={compleletStage}
                  setCompleteStage={setCompleteStage}
                  FormatingStepper={FormatingStepper}
                  setFormatingStepper={setFormatingStepper}
                  mainTransaction={mainTransaction}
                  advanceSearch={props?.advanceSearch} 
                  setRenderCheck={setRenderCheck}
                  renderCheck={renderCheck}
                  object={object}
                />
       })
    if(sections?.length>0 && cureentStageTransactionType?.id){
        
      
        
         sections.map((data)=>{
           
            let accecc_arr=[]
            console.log('log-1')
              if(permissionsForCurrentStage){
               console.log('log-1.1')

                accecc_arr =getCurrentPermissionForThisRoles(data?.id)
              }
              else{
               console.log('log-1.2')

                accecc_arr =getCurrentPermissionForThisRoles2(data?.id)
              }
             
               
            let check=false;
            if(accecc_arr?.length>0){
              check=true
            }else{
              check=false
            }

             if(cureentStageTransactionType?.id==1){
                if(data?.id==1&&check){
                    arr.push({
                      label:"معلومات اساسية",
                      content:<BasicInfo 
                      object={object} Access={accecc_arr} 
                      setRenderCheck={setRenderCheck}
                      getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                      renderCheck={renderCheck} advanceSearch={props?.advanceSearch} 
                      section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                     
                    })
                }else if(data?.id==2&&check){
                  arr.push(
                    {
                      label:"معلومات بطاقة الاحوال المدنية",
                      content:<CivilStatusCard 
                      object={object} Access={accecc_arr} 
                      getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                      advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id} /> 
                    }
                  )
                }else if(data?.id==3&&check){
                  arr.push({
                    label:"معلومات عنوان المنزل",
                    content:<HomeAddress 
                    object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                    advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }else if(data?.id==4&&check){
                  arr.push({
                    label:"معلومات المهنة",
                    content:<CareerInfo 
                    object={object} Access={accecc_arr} 
                     getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }else if(data?.id==5&&check){
                  arr.push({
                    label:"معلومات ارقام الهاتف",
                    content:<PhoneNumber 
                    object={object} Access={accecc_arr}   getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                    advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }else if(data?.id==6&&check){
                  arr.push({
                    label:"معلومات الحالة الزوجية",
                    content:<MaritalStatus 
                    object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                    advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }else if(data?.id==7&&check){
                  arr.push({
                    label:"معلومات الوكالة",
                    content:<SignatureOfTaxPayer 
                    object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                    advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }else if(data?.id==8&&check){
                  arr.push(
                    {
                      label:"الاولاد المشمولين بالسماح",
                      content:<ChildredList 
                      object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                      advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                    })
                }else if(data?.id==9&&check){
                  arr.push(
                    {
                      label:"المرفقات",
                      content:<ImagesUpload 
                      object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                      advanceSearch={props?.advanceSearch} section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                    })
                }else if(data?.id==10&&check){
                  arr.push({
                    label:"تصدير",
                    content:<ExportPdf 
                    object={object} Access={accecc_arr}  getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                    section_id={data?.id} stage_transaction_type_id={cureentStageTransactionType?.id}/>
                  })
                }
             }else if(cureentStageTransactionType?.id==2||cureentStageTransactionType?.id==3){
               
             if(data?.id==11&&check){
                arr.push({
                  label:`${data?.name}`,
                  content: <SourceOfIncome 
                         userRole={userRole}
                         setListOFIncomeResourceValue={setListOFIncomeResourceValue}
                         listOFIncomeResourceValue={listOFIncomeResourceValue}
                         setResourceForIncomeResource={setResourceForIncomeResource}
                         incomeResourceValuesArrOBJ={incomeResourceValuesArrOBJ}
                         setOtherResourceForIncomeResource={setOtherResourceForIncomeResource}
                         disableIncome={disableIncome}
                         selecetedAmount={selecetedAmount}
                         getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                         setAmountForIncomeResource={setAmountForIncomeResource}
                         summationOfAllResourcesFunction={summationOfAllResourcesFunction}
                         setsnackBar={setsnackBar}
                         snackBar={snackBar}
                         setCommentsForIncomeResource={setCommentsForIncomeResource}
                         ModeOfInsertData_tow={ModeOfInsertData_tow}
                         ModeOfInsertData={ModeOfInsertData}
                         getCalculationsForAmount={getCalculationsForAmount}
                         storeDataOfForm={storeDataOfForm}
                         loading={loading}
                         
                         object={object} 
                         Access={accecc_arr}
                         advanceSearch={props?.advanceSearch} 
                         section_id={data?.id}
                         stage_transaction_type_id={cureentStageTransactionType?.id}
                         setRenderCheck={setRenderCheck}
                         renderCheck={renderCheck}
                         setSectionSelected={setSectionSelected}
                       />
                })
             }
             if(data?.id==12&&check){
              arr.push({
                label:`${data?.name}`,
                content: <SummationOfIncomeResources 
                        summationOfAllResources={summationOfAllResources}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}

                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        loading={loading}
                        
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
              })
             } 
             if(data?.id==13&&check){
              arr.push({
                label:`${data?.name}`,
                content: <Discounts 
                        userRole={userRole}
                        setListOFDiscountValuesArrOBJ={setListOFDiscountValuesArrOBJ}
                        listOFDiscountValuesArrOBJ={listOFDiscountValuesArrOBJ}
                        setDiscountReasonIDAndName={setDiscountReasonIDAndName}
                        discountValuesArrOBJ={discountValuesArrOBJ}
                        setDiscountReasonOtherReason={setDiscountReasonOtherReason}
                        setDiscountReasonAmount={setDiscountReasonAmount}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
              })
             } 
             if(data?.id==14&&check){
              arr.push({
                label:`${data?.name}`,
                content: <Permitted 
                        userRole={userRole}
                        FinalCalculation={FinalCalculation}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
              })
             } 
             if(data?.id==15&&check){
              arr.push({
                label:`${data?.name}`,
                content: <TaxableIncome 
                        userRole={userRole}
                        taxableIncome={taxableIncome}
                        setTaxableIncom={setTaxableIncom}
                        taxableAmount={taxableAmount}
                        setTaxableAmount={setTaxableAmount}  
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
              })
             } 
             if(data?.id==16&&check){
               arr.push({
                label:`${data?.name}`,
                content: <Fines 
                        userRole={userRole}
                        setListOFFinesValuesArrOBJ={setListOFFinesValuesArrOBJ}
                        listOFFinesValuesArrOBJ={listOFFinesValuesArrOBJ}
                        setFinesIDAndName={setFinesIDAndName}
                        finesValuesArrOBj={finesValuesArrOBj}
                        setFinesOtherReason={setFinesOtherReason}
                        setFinesAmount={setFinesAmount}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
               })
             }
             if(data?.id==17&&check){
               arr.push({
                label:`${data?.name}`,
                content: <Interest 
                        userRole={userRole}
                        setListOFInterestedValuesArrOBj={setListOFInterestedValuesArrOBj}
                        listOFInterestedValuesArrOBj={listOFInterestedValuesArrOBj}
                        setInterestsIDAndName={setInterestsIDAndName}
                        interestedValuesArrOBj={interestedValuesArrOBj}
                        setInterestsOtherReason={setInterestsOtherReason}
                        setInterestAmount={setInterestAmount}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                         getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
               })
             }
             if(data?.id==18&&check){
               arr.push({
                label:`${data?.name}`,
                content: <PaymentsInfo 
                        userRole={userRole}
                        disableIncome={disableIncome}
                        voucherNumber={voucherNumber}
                        setVoucherNumber={setVoucherNumber}
                        voucherDate={voucherDate}
                        setVoucherDate={setVoucherDate}
                        finalTotalAmount={finalTotalAmount}
                        setOwnerDesision={setOwnerDesision}
                        ownerDecision={ownerDecision}
                        ownerDecisionDate={ownerDecisionDate}
                        setOwnerDecisionDate={setOwnerDecisionDate}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
               })
             }
             if(data?.id==19&&check){
               arr.push({
                label:`${data?.name}`,
                content: <CommentOfEstimators 
                        userRole={userRole}
                        setTaxAssessor={setTaxAssessor}
                        userName={userName}
                        taxAssessorComments={taxAssessorComments}
                        setTaxAssessorComments={setTaxAssessorComments}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                        
                      />
               })
             }
             if(data?.id==20&&check){
               arr.push({
                label:`${data?.name}`,
                content: <CommentsOfChecker 
                        userRole={userRole}
                        setCheckerName={setCheckerName}
                        userName={userName}
                        checkerNameComments={checkerNameComments}
                        setCheckerNameComments={setCheckerNameComments}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
               })
             }
             if(data?.id==21&&check){
               arr.push({
                label:`${data?.name}`,
                content: <CommentOfBranchManger 
                        userRole={userRole}
                        setBranchManager={setBranchManager}
                        userName={userName}
                        branchManagerComments={branchManagerComments}
                        setBranchManagerComments={setBranchManagerComments}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
               })
             }
             if(parseInt(cookies.get('role_id'))==3 || parseInt(cookies.get('role_id'))==0){
              if(data?.id==22&&check){
                arr.push({
                label:`${data?.name}`,
                content: <OtherBusinessForm 
                        userRole={userRole}
                        setBranchManager={setBranchManager}
                        userName={userName}
                        branchManagerComments={branchManagerComments}
                        setBranchManagerComments={setBranchManagerComments}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
                })
              }
              if(data?.id==23&&check){
                arr.push({
                label:`${data?.name}`,
                content: <IncomeEstimateClass 
                        userRole={userRole}
                        setBranchManager={setBranchManager}
                        userName={userName}
                        branchManagerComments={branchManagerComments}
                        setBranchManagerComments={setBranchManagerComments}
                        ModeOfInsertData_tow={ModeOfInsertData_tow}
                        ModeOfInsertData={ModeOfInsertData}
                        getCalculationsForAmount={getCalculationsForAmount}
                        storeDataOfForm={storeDataOfForm}
                        loading={loading}
                        getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                        object={object} 
                        Access={accecc_arr}
                        advanceSearch={props?.advanceSearch} 
                        section_id={data?.id}
                        stage_transaction_type_id={cureentStageTransactionType?.id}
                        setRenderCheck={setRenderCheck}
                        renderCheck={renderCheck}
                        setSectionSelected={setSectionSelected}
                      />
                })
              }
             }

             }
            
         })

    }
    setTabsArray(arr)
    

  
  },[sections,cureentStageTransactionType,permissionsForCurrentStage,renderCheck,FormatingStepper,loading,compleletStage])





 
//get seleceted amount for income resources.
const getSelectedAmountForIncomeResource = async () => {
  let data = [];
  try {
    data = await axios({
      method: "post",
      url: ApiSetting.apiUrl+ "/income_estimate_form/calculateAmount",
      data: {
        income_tax_report_id: props?.object?.id,
        // income_resource_value:''
      },
      headers: {
        "Content-Type": "applications/json",
        Accept: "applications/json",
      },
    });
    if (data) {
      if (data.data.status == 200) {
        if (data.data.data?.amount > 0) {
          setListOFIncomeResourceValue((itm)=>[...itm,{
            index: 1,
            resource: "نتيجة الحاسبة (تصاريح وحاسبة)",
            other_resource_value: '',
            amount: data.data.data?.amount,
            comments: data.data.data?.notes,
          }])
          setSelecetedAmount(data.data.data.total_amount);
          // let arr = [];
          // if (selecetedAmount.length > 0) {
          //   let chk = 0;
          //   selecetedAmount.map((itm) => {
          //     if (itm.index == values.index) {
          //       chk = 1;
          //       arr.push({ index: values.index, totlAmount: data.data.data });
          //     } else {
          //       arr.push(itm);
          //     }
          //   });
          //   if (chk == 0) {
          //     arr.push({ index: values.index, totlAmount: data.data.data });
          //   }
          //   setSelecetedAmount(arr);
          // } else {
          //   setSelecetedAmount((itm) => [
          //     ...itm,
          //     { index: values.index, totlAmount: data.data.data },
          //   ]);
          // }
          // setAmountForIncomeResource(values, data.data.data);
        }else{
          setListOFIncomeResourceValue((itm)=>[...itm,{
            index: 1,
            resource: "نتيجة الحاسبة (تصاريح وحاسبة)",
            other_resource_value: '',
            amount: 0,
            comments: '',
            hint:'لم يتم اضافة اي مقتبسات لهذا التقرير'
          }])
        }
      }else if(data.data.status==505){
          
      }  else {
        
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "warning",
          message: data.data.message,
        });
      }
    }
  } catch (err) {
    setsnackBar({
      ...snackBar,
      open: true,
      severity: "error",
      message: err.message,
    });
  }
};

const getSelectedAmountForIncomeResource_classess = async () => {
  let data = [];
  // setLoading1(true);
 
    try {
      data = await axios({
        method: "post",
        url:
          ApiSetting.apiUrl + "/income_estimate_form/getIncomeEstimateClass",
        data: {
          income_tax_report_id: props?.object?.id,
          income_resource_value: 'نتيجة اللجنة الفاحصة',
        },
        headers: {
          "Content-Type": "applications/json",
          Accept: "applications/json",
        },
      });
      if (data) {
        if (data.data.status == 200) {
          if (data.data.data && data.data.data?.total_amount >= 0) {
            setDisableIncome(data.data.data?.disable);

            setListOFIncomeResourceValue((itm)=>[...itm,{
              index: 0,
              resource: "نتيجة اللجنة الفاحصة",
              other_resource_value: '',
              amount: data.data.data?.total_amount,
              comments: data.data.data?.notes,
            }])
            
               
              
              setSelecetedAmount( data.data.data.total_amount);
            // let arr = [];
            // if (selecetedAmount.length > 0) {
            //   let chk = 0;
            //   selecetedAmount.map((itm) => {
            //     if (itm.index == values.index) {
            //       chk = 1;
            //       arr.push({
            //         index: values.index,
            //         totlAmount: data.data.data.total_amount,
            //         disabled: data.data.data.disable,
            //       });
            //     } else {
            //       arr.push(itm);
            //     }
            //   });
            //   if (chk == 0) {
            //     arr.push({
            //       index: values.index,
            //       totlAmount: data.data.data.total_amount,
            //       disabled: data.data.data.disable,
            //     });
            //   }
            //   setSelecetedAmount(arr);
            // } else {
            //   setSelecetedAmount((itm) => [
            //     ...itm,
            //     {
            //       index: values.index,
            //       totlAmount: data.data.data.total_amount,
            //       disabled: data.data.data.disable,
            //     },
            //   ]);
            // }
            // if (data.data.data?.total_amount >= 0)
            //   setAmountForIncomeResource(values, data.data.data.total_amount);
          }
          
        }else if(data.data.status==406){
          setListOFIncomeResourceValue((itm)=>[...itm,{
            index: 0,
            resource: "نتيجة اللجنة الفاحصة",
            other_resource_value: '',
            amount: 0,
            comments: '',
            hint:'لم يتم تشكيل لجنة او اسناد صنف لهذا التقرير'
          }])
        }else if(data.data.status==505){

        } else {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
      // setLoading1(false);
    } catch (err) {
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "warning",
        message: err.message,
      });
      setLoading1(false);
    }
  
};
const getCurresntSelectedTotalValue = (data) => {
  let totalAmount = 0;
  selecetedAmount.map((itm) => {
    if (itm.index == data.index) {
      totalAmount = itm.totlAmount;
    }
  });
  return totalAmount;
};

const getDisabledIncomeResource = (data) => {
  if (selecetedAmount.length > 0) {
    selecetedAmount.map((itm) => {
      if (
        itm.index == data.index &&
        data.resource == "نتيجة اللجنة الفاحصة"
      ) {
        return itm.disabled;
      }
    });
  }
};

//=====================get calaulation for resources====================================//
const getCalculationsForAmount = async (numb) => {
  let data = [];
  setLoading1(true);
  if(numb==2)
  setLoading2(true)
  try {
    data = await axios({
      method: "post",
      url:
        ApiSetting.apiUrl +
        "/income_estimate_form/getFinalCalculationsForAmount",
      data: {
        income_tax_report_id: props?.object?.id,
      },
      headers: {
        "Content-Type": "applications/json",
        Accept: "applications/json",
      },
    });
    if (data) {
      if (data.data.status == 200) {
        
        setFinalCalculation(data.data.data);
        setFinalTotalAmount(data.data.data?.total_income);

        if (data.data.data?.total_amount_befor_calculat) {
          setSummationOfAllResources(
            data.data.data.total_amount_befor_calculat
          );
        }

        if (data.data.data?.totla_income_required_for_tax) {
          setTaxableIncom(data.data.data.totla_income_required_for_tax);
        }

        if (data.data.data?.tax_amount) {
          setTaxableAmount(data.data.data.tax_amount);
        }

        setsnackBar({
          ...snackBar,
          open: true,
          severity: "success",
          message: data.data.message,
        });
      }else if( (cookies.get('role_id')!=3 && cookies.get('role_id')!=0 ) ) {
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "warning",
          message: data.data.message,
        });
      }
      if(numb==2){
      setModeOfInsertData_tow('تم الحساب')
      setLoading2(false)
      }
    }
    setLoading1(false);
  } catch (err) {
    setsnackBar({
      ...snackBar,
      open: true,
      severity: "warning",
      message: err.message,
    });
    if(numb==2){
    setModeOfInsertData_tow('تم الحساب')
     setLoading2(false)
    }
    setLoading1(false);
  }
};
//======================================================================================//

//get data if exists for report id that  sent.
const getRepordEstimateInfo = async (ipaddress) => {
  let data = null;
  try {
    data = await axios({
      method: "post",
      url: ipaddress + "/income_estimate_form/getinfoOfSelectedReport",
      data: {
        income_tax_report_id: props?.object?.id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (data) {
      if (data.data.status == 200 ) {
        formatDataFromRquet(data.data.data);
      }else if(data.data.status==407){

      } else if((cookies.get('role_id')!=3 && cookies.get('role_id')!=0 ) ) {
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "warning",
          message: data.data.message,
        });
      }
    }
  } catch (err) {
    setsnackBar({
      ...snackBar,
      open: true,
      severity: "error",
      message: err.message,
    });
  }
};

const formatDataFromRquet = (data) => {
  if (data) {
    setSummationOfAllResources(data.income_estimators_report?.total_income);
    setTaxableIncom(data.income_estimators_report?.total_income_requires_tax);
    setTaxableAmount(data.income_estimators_report?.tax_amount);
    setVoucherNumber(data.income_estimators_report?.receipt_number);
    setVoucherDate(data.income_estimators_report?.receipt_date);
    // setTaxAssessor(data.)
    setTaxAssessorComments(data.income_estimators_report?.estimator_note);
    setCheckerNameComments(data.income_estimators_report?.checker_note);
    setBranchManagerComments(
      data.income_estimators_report?.branch_admin_note
    );

    if(data.incomeResources)
    setListOFIncomeResourceValue((itm)=>[...itm,...data.incomeResources]);
    // if (data?.incomeResources.length > 0) {
    //   data.incomeResources.map((itm) => {
    //     getSelectedAmountForIncomeResource_classess(itm);
    //   });
    // }

    setListOFDiscountValuesArrOBJ(
      data.discountReason ? data.discountReason : []
    );
    setListOFFinesValuesArrOBJ(data.finesReason ? data.finesReason : []);
    setListOFInterestedValuesArrOBj(data.interests ? data.interests : []);
    setVoucherNumber(data?.income_estimators_report?.receipt_number);
    setVoucherDate(new Date(data?.income_estimators_report?.receipt_date));
    setFinalTotalAmount(data?.income_estimators_report?.final_total_amount);
    // setFina
    if (data?.income_estimators_report?.owner_decision == 1)
      setOwnerDesision(true);
    else if(data?.income_estimators_report?.owner_decision == 0) setOwnerDesision(false);

    setOwnerDecisionDate(
      new Date(data?.income_estimators_report?.owner_decision_date)
    );
    setModeOfInsertData("تحديث");
  } else if (!data) {
    setModeOfInsertData("أضافة");
  }
};

// ====================store data================================
const storeDataOfForm = async (section_id) => {
  let data = null;
  let ar=[];
  if(listOFIncomeResourceValue.length>0){
    listOFIncomeResourceValue.map(data=>{
      if(data.resource=='other'){
       ar.push(data)
      }
    })
  }


  let formData = {
    list_of_income_resource_values:(ownerDecision==false || ownerDecision==true?listOFIncomeResourceValue:ar), //
    summation_of_all_resources: summationOfAllResources, //....
    list_of_discount_values: listOFDiscountValuesArrOBJ, //
    taxable_income: taxableIncome, //....
    taxable_amount: taxableAmount, //....
    list_of_fines_values: listOFFinesValuesArrOBJ, //
    list_of_interested_values: listOFInterestedValuesArrOBj, //
    voucher_number: voucherNumber, //....
    voucher_date: userRole == 4 ? formatDate(voucherDate) : null, //....
    tax_assessor: taxAssessor, //....
    tax_assessor_comments: taxAssessorComments, //....
    checker_name: checkerName, //....
    checker_name_comments: checkerNameComments, //....
    branch_manager: branchManager, //....
    branch_manager_comments: branchManagerComments, //....
    role_id: parseInt(userRole)+1, //...
    income_tax_report_id: props?.object?.id, //....
    owner_decision: ownerDecision,
    owner_decision_date: formatDate(ownerDecisionDate),
    section_id:section_id
  };

  if(cookies.get('role_id')==4){
    swal({
      title: "هل انتة موافق?",
      text: "بمجرد عمل تحديث للبيانات لن تستطيع عمل تعديل لها مجددا!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then(async(willDelete) => {
      if (willDelete) {
      setLoading(true);
      try {
        data = await axios({
          method: "post",
          url: IPaddress + "/income_estimate_form/store",
          data: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (data) {
          if (data.data.status == 200) {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "success",
              message: data.data.message,
            });
           setLoading(false);

          } else if (data.data.status == 500) {
            setsnackBar2({
              ...snackBar2,
              open: true,
              severity: "warning",
              message: data.data.data,
            });
            // console.log(data.data.data);
          } else {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message: data.data.message,
            });
          }
        }
        setLoading(false);
      } catch (err) {
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "error",
          message: err.message,
        });
        setLoading(false);
      }
  }
});
  }else{

    setLoading(true);
    try {
      data = await axios({
        method: "post",
        url: IPaddress + "/income_estimate_form/store",
        data: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      if (data) {
        if (data.data.status == 200) {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "success",
            message: data.data.message,
          });
        setLoading(false);
        // setRenderCheck(!renderCheck);
        } else if (data.data.status == 500) {
          setsnackBar2({
            ...snackBar2,
            open: true,
            severity: "warning",
            message: data.data.data,
          });
          // setRenderCheck(!renderCheck);
          // console.log(data.data.data);
        } else {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
          // setRenderCheck(!renderCheck);
        }
      }
      setLoading(false);
    } catch (err) {
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
      setLoading(false);
      // setRenderCheck(!renderCheck);
    }

  }
};
// ====================end store data============================

//============format date to format yyyy-mm-dd============
const formatDate = (date) => {
  let y = date.getFullYear();

  let m = date.getMonth() + 1;
  if (m < 10) m = "0" + m;

  let d = date.getDate();
  if (d < 10) d = "0" + d;

  return y + "-" + m + "-" + d;
};

//============end format date==============================

// ====================Resources============================
//get resource name...
const setResourceForIncomeResource = (data, resource) => {
  let arrYTMp = [];
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // resource: resource,
          // other_resource_value: data.other_resource_value,
          // amount: data.amount,
          // comments: data.comments,
          ...data,
          resource: resource,
        };
        arrYTMp.push(custm);
        // if (resource == "نتيجة الحاسبة (تصاريح وحاسبة)") {
        //  getSelectedAmountForIncomeResource(custm);
        // } else if (resource == "نتيجة اللجنة الفاحصة") {
        //   getSelectedAmountForIncomeResource_classess(custm);
        // } 
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFIncomeResourceValue(arrYTMp);
  }
};
//get other resource name...
const setOtherResourceForIncomeResource = (data, other_resource) => {
  let arrYTMp = [];
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // resource: data.resource,
          // other_resource_value: other_resource,
          // amount: data.amount,
          // comments: data.comments,
          ...data,
          other_resource_value: other_resource,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFIncomeResourceValue(arrYTMp);
  }
};
//get amount ...
const setAmountForIncomeResource = (data, amount) => {
  let arrYTMp = [];
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // resource: data.resource,
          // other_resource_value: data.other_resource_value,

          // comments: data.comments,
          ...data,
          amount: amount ? amount : 0,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFIncomeResourceValue(arrYTMp);
  }
};
//get comments ...
const setCommentsForIncomeResource = (data, comment) => {
  let arrYTMp = [];
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // resource: data.resource,
          // other_resource_value: data.other_resource_value,
          // amount: data.amount,
          // comments: comment,
          ...data,
          comments: comment,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFIncomeResourceValue(arrYTMp);
  }
};

//get summation of all resources  for any update...
const summationOfAllResourcesFunction_update = () => {
  let sum = 0;
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      // if (data.index != dataItem.index) {
      if (!isNaN(dataItem.amount)) sum += parseInt(dataItem.amount);
      // }
    });
  }
  setSummationOfAllResources(sum);
  // return sum;
};

//get summation of all resources...
const summationOfAllResourcesFunction = (data, value) => {
  let sum = parseInt(value);
  if (listOFIncomeResourceValue.length > 0) {
    listOFIncomeResourceValue.map((dataItem) => {
      if (data.index != dataItem.index) {
        if (!isNaN(dataItem.amount)) sum += parseInt(dataItem.amount);
      }
    });
  }
  setSummationOfAllResources(sum);
  // return sum;
};
//===========================================================

// ====================discountreason============================
//get reason name...
const setDiscountReasonIDAndName = (data, reason) => {
  let arrYTMp = [];
  if (listOFDiscountValuesArrOBJ.length > 0) {
    listOFDiscountValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: reason,
          // other_reason_value: data.other_reason_value,
          // amount: data.amount,
          ...data,
          reason: reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFDiscountValuesArrOBJ(arrYTMp);
  }
};
//get other reason name...
const setDiscountReasonOtherReason = (data, other_reason) => {
  let arrYTMp = [];
  if (listOFDiscountValuesArrOBJ.length > 0) {
    listOFDiscountValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: other_reason,
          // amount: data.amount,
          ...data,
          other_reason_value: other_reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFDiscountValuesArrOBJ(arrYTMp);
  }
};
//get amount ...
const setDiscountReasonAmount = (data, amount) => {
  let arrYTMp = [];
  if (listOFDiscountValuesArrOBJ.length > 0) {
    listOFDiscountValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: data.other_reason_value,
          // amount: amount,
          ...data,
          amount: amount,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFDiscountValuesArrOBJ(arrYTMp);
  }
};
//===========================================================

// ====================fines============================
//get fines reason name...
const setFinesIDAndName = (data, reason) => {
  let arrYTMp = [];
  if (listOFFinesValuesArrOBJ.length > 0) {
    listOFFinesValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: reason,
          // other_reason_value: data.other_reason_value,
          // amount: data.amount,
          ...data,
          reason: reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFFinesValuesArrOBJ(arrYTMp);
  }
};
//get other fines reason name...
const setFinesOtherReason = (data, other_reason) => {
  let arrYTMp = [];
  if (listOFFinesValuesArrOBJ.length > 0) {
    listOFFinesValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: other_reason,
          // amount: data.amount,
          ...data,
          other_reason_value: other_reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFFinesValuesArrOBJ(arrYTMp);
  }
};
//get amount of fines...
const setFinesAmount = (data, amount) => {
  let arrYTMp = [];
  if (listOFFinesValuesArrOBJ.length > 0) {
    listOFFinesValuesArrOBJ.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: data.other_reason_value,
          // amount: amount,
          ...data,
          amount: amount,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFFinesValuesArrOBJ(arrYTMp);
  }
};
//===========================================================

// ====================interest============================
//get Interests reason name...
const setInterestsIDAndName = (data, reason) => {
  let arrYTMp = [];
  if (listOFInterestedValuesArrOBj.length > 0) {
    listOFInterestedValuesArrOBj.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: reason,
          // other_reason_value: data.other_reason_value,
          // amount: data.amount,
          ...data,
          reason: reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFInterestedValuesArrOBj(arrYTMp);
  }
};
//get other Interests reason name...
const setInterestsOtherReason = (data, other_reason) => {
  let arrYTMp = [];
  if (listOFInterestedValuesArrOBj.length > 0) {
    listOFInterestedValuesArrOBj.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: other_reason,
          // amount: data.amount,
          ...data,
          other_reason_value: other_reason,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFInterestedValuesArrOBj(arrYTMp);
  }
};
//get amount of Interests...
const setInterestAmount = (data, amount) => {
  let arrYTMp = [];
  if (listOFInterestedValuesArrOBj.length > 0) {
    listOFInterestedValuesArrOBj.map((dataItem) => {
      if (data.index == dataItem.index) {
        let custm = {
          // index: data.index,
          // reason: data.reason,
          // other_reason_value: data.other_reason_value,
          // amount: amount,
          ...data,
          amount: amount,
        };
        arrYTMp.push(custm);
      } else {
        arrYTMp.push(dataItem);
      }
    });
    setListOFInterestedValuesArrOBj(arrYTMp);
  }
};
//===========================================================


  const handleClose = () => {
    props?.setOpen(false);
  };
  if(loadFetchData)
   return <Loading/>
  else
  return (
  
      <div style={{
        // display: 'flex',
        // flexDirection: 'row',
        // flexFlow: 'row wrap',
        width: '100%',
        height:'600',
      }}>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          backgroundColor: '#5f7b8a',
          color: '#FFFFFF',
          paddingTop: 10,
          paddingBottom: 10,
          // borderTopLeftRadius: 10,
          // borderTopRightRadius: 10,
          // justifyContent: 'center',
          // alignItems: 'center'
        }}
        className="StepperIncomeTaxReport"
        
        >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{position: "relative",top:'-15px',right:'15px'}}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, width:"20%",position: "relative",top:'-15px' }} variant="h6" component="div">
             عرض حالة وتفاصيل التقرير
            </Typography>
            <StepperIncomeTaxReport 
                compleletStage={compleletStage}
                setCompleteStage={setCompleteStage}
                object={object}
                FormatingStepper={FormatingStepper}
                setFormatingStepper={setFormatingStepper}
                getCurrentReportDataAfterUpdate={getCurrentReportDataAfterUpdate}
                setObject={setObject} advanceSearch={props?.advanceSearch} render={props?.render} 
                setRender={props?.setRender} renderCheck={renderCheck} permissionsForCurrentStage={permissionsForCurrentStage}
                setRenderCheck={setRenderCheck} ModeOfInsertData={ModeOfInsertData} 
                loading2={loading2} storeDataOfForm={storeDataOfForm}  activeStep={activeStep} setActiveStep={setActiveStep}
                setSections={setSections} cureentStageTransactionType={cureentStageTransactionType}
                setCurrentStageTransactionType={setCurrentStageTransactionType} setPermissions={setPermissions}
                setPermissionsForCurrentStage={setPermissionsForCurrentStage} loading={loading} 
                getCalculationsForAmount={getCalculationsForAmount}
                setMainTransaction={setMainTransaction}
                />
        </div>

       
        
        {object?
        <>
       
   

        <VerticalTabs tabsArray={tabsArray}  />
        {/* <BasicInfo object={object} /> */}
        {/* <CivilStatusCard object={object} /> */}
        {/* <HomeAddress object={object} /> */}
        {/* <CareerInfo object={object}/> */}
        {/* <PhoneNumber object={object}/> */}
        {/* <MaritalStatus object={object}/> */}
        {/* <MaritalStatusOtherInfo object={object}/> */}
        {/* <SignatureOfTaxPayer object={object}/> */}

        {/* <ChildredList object={object}/> */}
        {/* <ImagesUpload object={object}/> */}

        {/* <SubmitButton object={object}/> */}
        </>:null}

        

        {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => {
          setsnackBar({ ...snackBar, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar.vertical,
          horizontal: snackBar.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar({ ...snackBar, open: false });
          }}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>

      {/* snack alert box here ... */}
      <Snackbar
        sx={{ height: "100%" }}
        open={snackBar2.open}
        // autoHideDuration={6000}
        onClose={() => {
          setsnackBar2({ ...snackBar2, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar2.vertical,
          horizontal: snackBar2.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar2({ ...snackBar2, open: false });
          }}
          severity={snackBar2.severity}
          sx={{ width: "100%" }}
        >
          {snackBar2.message?.length > 0
            ? snackBar2.message.map((mes) => <p>{mes}</p>)
            : ""}
        </Alert>
      </Snackbar>
      </div>

  );
}
